import app from "../base";
import React, { useState , useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../Auth";
import Logo from "../images/logo text.png" 
import "../App.css"
import "../css/bootstrap.css"
import "../css/styles.css"
import "../css/magnific-popup.css"
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import leftarrow from '../images/left.png';
import rightarrow from '../images/next.png';
import Arrythmia from '../images/Arrythmia.png';
import Brugada from '../images/Brugada.jpg';
import BB from '../images/BB.jpg';

const HardwareHistory = ({ history }) => {
    const { currentUser } = useContext(AuthContext);
    const [data , setData] = useState([]);
    const db = app.firestore();
    const [serial , setSerial]  = useState("");
    const [serialvalue , setSerialNumber]  = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    const Signout = () => {
      app.auth().signOut();
      history.push("/");
      window.location.reload(true)
    };

    const links = document.querySelectorAll('.profile-info li a');

    const [sidebar, setSidebar] = useState(false);

    links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        link.style.backgroundColor = '#3E8E41';
      });
    
      link.addEventListener('mouseleave', () => {
        link.style.backgroundColor = '#4CAF50';
      });
    });

    const handleClick = () => {
        console.log(`Serial number entered: ${serial}`);
        setSerial(serialvalue);
    }
    
    const ToggleSideBar = () => {
      setSidebar(!sidebar);
    }

    
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 600);
      };
      window.addEventListener("resize", handleResize);

      const unsubscribe = db.collection("DATAEKG2").where("serial_id", "==", serial)
    .onSnapshot((querySnapshot) => {
      let dataArray = [];
      querySnapshot.forEach((doc) => {
        dataArray.push(doc.data());
        dataArray.sort((lhs, rhs) => {
          if (lhs.status === "Notplotted" && rhs.status !== "Notplotted") {
            return -1;
          } else if (lhs.status !== "Notplotted" && rhs.status === "Notplotted") {
            return 1;
          } else if (lhs.Time !== rhs.Time) {
            return ((lhs.Time < rhs.Time) - 0.5) * 2;
          }
          return 0;
        });        

      });
      setData(dataArray);
      console.log(dataArray)
      console.log(serial)
    });
    return () => {
    window.removeEventListener("resize", handleResize);
    unsubscribe();
  }
  }, [db, serial])

  

  
  
    return(
      <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              บริการ <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              ข่าวสารจาก EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/about">
              เกี่ยวกับเรา
            </Nav.Link>
          </li>
        </center>
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >ออกจากระบบ</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" onClick={ToggleSideBar}>
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/HardwareHistory">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/HardwareHistory">
              EN
            </Nav.Link>
          </li>
        </center>
        
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>

  {isMobile ? <div>
    <div className="font-face-gr" >
  <header  className="ex-header bg-gray  " style={{zIndex: "1"}}  >
    <div className="container" >
      <div className="row">
        <div className="col-xl-10 offset-xl-1" >
          <p>กดปุ่มนี้เพื่อใส่เลขเครื่อง</p>
          
          <center>
          <h1 className="font-face-gm">ประวัติการตรวจวัดค่า กราฟคลื่นไฟฟ้าหัวใจ ด้วยอุปกรณ์</h1>
          
          {/* <div class="form-group col-sm-8 col-form-label mb-2">
                
                <input type="email" class="form-control" id="exampleInputEmail1" placeholder = "กรอกเลขเครื่อง" aria-describedby="emailHelp" maxlength="4"
                value={serialvalue}
                onChange={event => setSerialNumber(event.target.value)} style = {{marginButtom: "10px"}}></input>
                <button className="btn-solid-lg " style = {{marginTop: "10px"}} onClick={handleClick} >ค้นหา</button>
          </div> */}
          </center>
          
        </div>{" "}

        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </header>{" "}
  </div>


  <center>

  
 
  <a className = "sidenav2" style={{marginTop: "21%", marginLeft: "40px", left: sidebar ? "0" : '-60%', transition: "350ms", width: "60%" }} onClick={ToggleSideBar}> 
    <img style={{marginLeft: "80%", width:"20%", height:"100%"}} src={sidebar ? leftarrow : rightarrow}></img>
  </a>
        


  <div className="sidenav" style={{left: sidebar ? "0" : '-100%', transition: "350ms", width: "60%" }} sidebar={sidebar}>
              
              <center>
              <div class="mx-auto py-4 fs-1  mt-5">
              
              
              
              <img style={{width: "20%", height: "20%"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  /><br></br>
              <h1 className="font-face-gm">EIPCA ยินดีต้อนรับ</h1><br></br>
              <p class=" py-1  fw-bold " style={{fontSize: "80%"}}>{currentUser.displayName}</p>
              <p class=" py-1  " style={{fontSize: "50%"}}>{currentUser.email}</p>
              </div>

              
              
              
             
              <div class="form-group col-sm-8 col-form-label mb-2">
               
                <input type="email" class="form-control" id="exampleInputEmail1" placeholder = "Input serial number" aria-describedby="emailHelp" maxlength="4"
                value={serialvalue}
                onChange={event => setSerialNumber(event.target.value)}></input>
                <div id="emailHelp" class="form-text">รหัสเครื่อง 4 ตัวของท่านอยู่ใต้บรรจุภัณฑ์ </div>
                </div>
              </center>
              <button className="btn-solid-lg " onClick={handleClick} >
                ตรวจผลการวัดค่า
                
                </button>
  </div>
  
  </center>
  </div> 
  
  : 

  
  <div>
    <header  className="ex-header bg-gray fixed-top " style={{zIndex: "1", marginLeft: "10%"}}  >
    <div className="container" >
      <div className="row">
        <div style={{ marginLeft: "22%"}} className="col-xl-10 offset-xl-1" >
          <h1 >ประวัติการตรวจวัดค่า กราฟคลื่นไฟฟ้าหัวใจ ด้วยอุปกรณ์</h1>

        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </header>{" "}
 


  <center>      
  <div style={{marginBottom: "17%"}}>.</div>
  <div className="sidenav">
              <center>
              <div class="mx-auto py-4 fs-1  mt-5">
              
              <img style={{width: "20%", height: "20%"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  /><br></br>
              <h1>EIPCA ยินดีต้อนรับ</h1><br></br>
              <p class=" py-1  fw-bold " style={{fontSize: "80%"}}>{currentUser.displayName}</p>
              <p class=" py-1  " style={{fontSize: "50%"}}>{currentUser.email}</p>
              </div>
              {/* <div class=" py-4 fs-1 fw-bold mt-5">ประวัติการตรวจวัดค่า กราฟคลื่นไฟฟ้าหัวใจ</div> */}
              {/* <p>Please be patient for AI the Predicted the ECG graph</p> */}
              
              <div class="form-group col-sm-8 col-form-label mb-2">
                <label for="exampleInputEmail1" class="form-label">Input Serial Number</label>
                <input type="email" class="form-control" id="exampleInputEmail1" placeholder = "Input serial number" aria-describedby="emailHelp" maxlength="4"
                value={serialvalue}
                onChange={event => setSerialNumber(event.target.value)}></input>
                <div id="emailHelp" class="form-text">รหัสเครื่อง 4 ตัวของท่านอยู่ใต้บรรจุภัณฑ์ </div>
                </div>
              </center>
              <button className="btn-solid-lg " onClick={handleClick} >
                ตรวจผลการวัดค่า
                </button>
  </div>
  
  </center>
  </div>}

  
  
      
   
          <center>
            <ul style={{paddingInline: "20px"}}>
              {data.map((item) => (
              <Frame 
                Results = {item.Result}
                Status = {item.graph_status} 
                Time = {item.Time}
                File = {item.graph_image}
                History = {item.History}
                Confidence = {item.confidence}
                BoxIMG = {item.box_image}

              />
              ))}
             
            </ul>
          
            </center>
            
        </>
      
    );
  };

const Frame = ({ Results, Status, Time, File, Confidence, BoxIMG}) => {
  const [isDataShown, setIsDataShown] = useState(false);
  const [Formstatus, setFormstatus] = useState("");
  const db = app.firestore();
  const { currentUser } = useContext(AuthContext);
  let ResultRisk;
  const [noformElement, setNoformElement] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect (() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    window.addEventListener("resize", handleResize);

    const documentRef = db.collection('EIPCAFORM').doc(currentUser.uid);
    documentRef.get().then((doc) => {
      if (doc.exists) {
        let formstatusArray = [];
        formstatusArray.push(doc.data());
        const myStringValue = formstatusArray[0].Form_Result;
        setFormstatus(myStringValue);
      } else {
        const noform = <p class = "font-face-gm my-2">
        คุณยังไม่ได้ทำแบบสอบถาม กรุณาทำแบบสอบถามเพื่อดูผลการตรวจสอบ<br></br>
        <button className="btn-solid-lg" onClick={() => window.location.assign("/Form")}> ทำแบบฟอร์ม</button>
        </p>
        
        setNoformElement(noform);

      }
    }).catch((error) => {
      console.log("Error getting document:", error);
    });
    return () => window.removeEventListener("resize", handleResize);
  }) 

  const toggleData = () => {
    setIsDataShown(!isDataShown);
  };

  const handleDelete = () => {
    db.collection("DATAEKG2")
      .where("Time", "==", Time)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          doc.ref.delete().then(() => {
            console.log("Document successfully deleted!");
          }).catch((error) => {
            console.error("Error removing document: ", error);
          });
        });
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  let deleteButton;
  if (currentUser.uid === "UTE8Z9cUgTUikHN3bU09mEL3OBw2") {
    deleteButton = (
      <button className="btn btn-danger btn-sm" onClick={handleDelete}>
        Delete
      </button>
    );
  }
   
  if (Formstatus === "High_Risk" && Results !== "Normal") {
    ResultRisk = "High";
  } else if (Formstatus === "Medium_Risk" && Results !== "Normal") {
    ResultRisk = "High";
  } else if (Formstatus === "High_Risk" && Results === "Normal") {
    ResultRisk = "Low";
  } else if (Formstatus === "Medium_Risk" && Results === "Normal") {
    ResultRisk = "Low";
  } else if (Formstatus === "Low_Risk" && Results !== "Normal") {
    ResultRisk = "Medium";
  } else if (Formstatus === "No_Risk" && Results !== "Normal") {
    ResultRisk = "Medium";
  } else if (Formstatus === "Low_Risk" && Results === "Normal") {
    ResultRisk = "None";
  } else if (Formstatus === "No_Risk" && Results === "Normal") {
    ResultRisk = "None";
  }

  let imgset;
  if (Results === "Branch Block"){
    imgset = BB
  } else if (Results === "Cardiac Arrhythmia"){
    imgset = Arrythmia
  } else if (Results === "Brugada Syndrome"){
    imgset = Brugada
  } 

  let ResultInput;
  if (ResultRisk === "High") {
    ResultInput = 
    <div >
    <h5 clasName="my-2" style={{color: "red"}}>คุณมีความเสี่ยงสูงที่จะมีภาวะผิดปกติเกี่ยวกับหัวใจ โปรดอ่านข้อแนะนำ</h5>
    <p>ตรวจพบความเสี่ยงกราฟคลื่นหัวใจแบบภาวะ {Results} {Confidence}</p>
     <img
      className="img-fluid img-thumbnail "
      style={{
      borderColor: "Red",
      borderWidth: "2px",
      maxHeight: "40%",
      maxWidth: "90%",
      marginLeft: "8%"
       }}
        src={File}
        alt="Image from data"
        />
      <p>ภาพเปรียบเทียบ จากรูปกราฟ ECG แบบ {Results} </p>
      <img className="img-fluid img-thumbnail "  style={{
            maxHeight: "40%",
            maxWidth: "90%",  
            marginLeft: "8%"
              }}
            src={imgset}/>
      <img className="img-fluid img-thumbnail "  style={{
            maxHeight: "40%",
            maxWidth: "90%",  
            marginLeft: "8%"
              }}
            src={BoxIMG}
            alt="Boxed Image"/>
      <br/>
      <br/>
      <a  className="btn-solid-lg page-scroll mx-5 " href="/SuggestionHealthy">
      ข้อแนะนำ
      </a>
      <a  className="btn-solid-lgr page-scroll " href="/SuggestionHospital2">
      ค้นหาโรงพยาบาล
      </a>
      </div>
  } else if (ResultRisk === "Medium") {
    ResultInput = 
    <div >
    <h5 clasName="my-2" style={{color: "Darkorange"}}>คุณมีความเสี่ยงปานกลางที่จะมีภาวะผิดปกติเกี่ยวกับหัวใจ โปรดอ่านข้อแนะนำ</h5>
    <p>ท่านอาจจะมีความเสี่ยงกราฟคลื่นหัวใจแบบภาวะ {Results} {Confidence}</p>
     <img
      className="img-fluid img-thumbnail "
      style={{
      borderColor: "Darkorange",
      borderWidth: "2px",
      maxHeight: "40%",
      maxWidth: "90%",
      marginLeft: "8%"
       }}
        src={File}
        alt="Image from data"
        />
      <p>ภาพเปรียบเทียบ จากรูปกราฟ ECG แบบ {Results} </p>
      <img className="img-fluid img-thumbnail "  style={{
            maxHeight: "40%",
            maxWidth: "90%",  
            marginLeft: "8%"
              }}
            src={imgset}/>
      <br/>
      <br/>
      <a  className="btn-solid-lg page-scroll mx-5 " href="/SuggestionHealthy">
      ข้อแนะนำ
      </a>
      <a  className="btn-solid-lgr page-scroll " href="/SuggestionHospital2">
      ค้นหาโรงพยาบาล
      </a>
      </div>
  } else if (ResultRisk === "Low") {
    ResultInput = 
    <div >
    <h5 clasName="my-2" style={{color: "DarkGreen"}}>คุณมีความเสี่ยงต่ำที่จะมีภาวะผิดปกติเกี่ยวกับหัวใจ โปรดอ่านข้อแนะนำ</h5>
    <p>ผลตรวจกราฟคลื่นไฟฟ้าหัวใจของคุณปกติ เพื่อความมั่นใจ ท่านสามารถไปตรวจสอบเพิ่มได้ที่สถานพยาบาล </p>
     <img
      className="img-fluid img-thumbnail "
      style={{
      borderColor: "DarkGreen",
      borderWidth: "2px",
      maxHeight: "40%",
      maxWidth: "90%",
      marginLeft: "8%"
       }}
        src={File}
        alt="Image from data"
        />
      <br/>
      <br/>
      <a  className="btn-solid-lg page-scroll mx-5 " href="/SuggestionHealthy">
      ข้อแนะนำ
      </a>
      <a  className="btn-solid-lgr page-scroll " href="/SuggestionHospital2">
      ค้นหาโรงพยาบาล
      </a>
      </div>
  } else if (ResultRisk === "None") {
    ResultInput = 
    <div>
            <h5 clasName="my-2" style={{color: "green"}}>คุณไม่มีความเสี่ยงเกี่ยวกับหัวใจ</h5>
            <p>คุณมีกราฟคลื่นหัวใจแบบแบบปกติ</p>
        <img
          className="img-fluid img-thumbnail"
          style={{
          borderColor: "green",
          borderWidth: "2px",
          maxHeight: "40%",
          maxWidth: "90%",
      marginLeft: "8%"
        }}
        src={File}
        alt="Image from data"
      />
      <br/>
      <br/>
       <a  className="btn-solid-lg page-scroll " href="/SuggestionHealthy">
      ข้อแนะนำ
      </a>
      </div>
  }
 
    return(
      
    <p>
    {Status === "Notplotted" && ( isMobile ? (
    <p className="bg-warning py-3 fs-5" >
        <div className="fw-bold">Date&Time : {Time}</div> <br />
        <div>สถานะ : กำลังประมวลผล</div> <br />
        <div className="d-flex justify-content-center">
          <div className="spinner-border mr-3 " role="status"></div>
          <span className="fs-5 mx-2"> AI Processing...</span>
        </div>
      </p> 
      ) : ( 
        <p className="bg-warning py-3 fs-5" style={{marginLeft: "15%"}} >
        <div className="fw-bold">Date&Time : {Time}</div> <br />
        <div>สถานะ : กำลังประมวลผล</div> <br />
        <div className="d-flex justify-content-center">
          <div className="spinner-border mr-3 " role="status"></div>
          <span className="fs-5 mx-2"> AI Processing...</span>
        </div>
      </p> 
      ))}  


    {Status === "Plotted and Predicted" && Results === "Normal" && ( isMobile ? (
      <p className="bg-light py-3 fs-5" >
      <div className="fw-bold">Date&Time : {Time}</div> <br />
      <div>สถานะ : ประมวลผลเสร็จสิ้น </div> <br />
      <button className="btn-solid-lg" onClick={toggleData}>
        {isDataShown ? "Hide Results" : "Show Results"}
      </button>
     
    </p>
    ) : (
      <p className="bg-light py-3 fs-5" style={{marginLeft: "15%"}} >
        <div className="fw-bold">Date&Time : {Time}</div> <br/>
        <div>สถานะ : ประมวลผลเสร็จสิ้น </div> <br />
        <button className="btn-solid-lg" onClick={toggleData}>
          {isDataShown ? "Hide Results" : "Show Results"}
        </button>
       
      </p>
    ))}

    {Status === "Plotted and Predicted" && Results !== "Normal" && ( isMobile ? (
      <p className="bg-light py-3 fs-5" >
      <div className="fw-bold">Date&Time : {Time}</div> <br />
      <div style={{color : "red"}} >สถานะ : ประมวลผลเสร็จสิ้น (มีความเสี่ยง) </div> <br />
      <button className="btn-solid-lg" onClick={toggleData}>
        {isDataShown ? "Hide Results" : "Show Results"}
      </button>
     
    </p>
    ) : (
      <p className="bg-light py-3 fs-5" style={{marginLeft: "15%"}} >
        <div className="fw-bold">Date&Time : {Time}</div> <br/>
        <div style={{color : "red"}} >สถานะ : ประมวลผลเสร็จสิ้น (มีความเสี่ยง) </div> <br />
        <button className="btn-solid-lg" onClick={toggleData}>
          {isDataShown ? "Hide Results" : "Show Results"}
        </button>
       
      </p>
    ))}


  {isDataShown && Status === "Plotted and Predicted" && (isMobile ? (
  <div className="py-3 fs-5"  >
    <h2 className="font-face-gm">ผลการตรวจสอบ</h2>
    <div>{ResultInput}</div>
    <div>{noformElement}</div>
    <br/>
    <br/>
  </div>
) : (
  <div className="py-3 fs-5" style={{marginLeft: "15%"}} >
    <h2 className="font-face-gm">ผลการตรวจสอบ</h2>
    <div>{deleteButton}</div>
    <div>{ResultInput}</div>
    <div>{noformElement}</div>
    <br/>
    <br/>
  </div>
))}
  </p>
);
}

export default withRouter(HardwareHistory);